import { useState } from 'react';
import { contact, payrollIncludes, payrollTiers } from '../data';

export default function PayrollPricing() {
  const [employees, setEmployees] = useState('');

  const count = Number(employees);
  const isValid = Number.isInteger(count) && count >= 1 && count <= 50;
  const tier = isValid ? payrollTiers.find((item) => count <= item.max) : null;
  const displayPrice = tier ? tier.price : payrollTiers[0].price;

  return (
    <section className="section payroll" id="payroll" aria-labelledby="payroll-heading">
      <div className="container">
        <div className="section-head" data-reveal>
          <p className="eyebrow">Payroll</p>
          <h2 className="display-2" id="payroll-heading">
            Managed <em>Payroll</em>
          </h2>
          <p className="section-lede">
            Reliable payroll processing using your existing payroll platform, with simple monthly
            pricing based on the size of your team.
          </p>
        </div>

        <div className="payroll-band" data-reveal>
          <div className="payroll-band-cell payroll-input-cell">
            <p className="payroll-cell-label">Payroll calculator</p>
            <label className="field-label" htmlFor="employee-count">
              How many people are on payroll?
            </label>
            <div className="employee-input-wrap">
              <input
                id="employee-count"
                className="field-input"
                type="number"
                inputMode="numeric"
                min="1"
                max="50"
                step="1"
                placeholder="Enter team size"
                value={employees}
                onChange={(event) => setEmployees(event.target.value)}
                aria-describedby="employee-count-help"
              />
            </div>
            <p className="field-help" id="employee-count-help">
              Up to 50 people
            </p>
            {employees !== '' && !isValid && (
              <p className="field-error" role="alert">
                Enter a whole number from 1 to 50.
              </p>
            )}
          </div>

          <div className="payroll-band-cell payroll-rate-cell" role="status">
            <p className="payroll-cell-label">Monthly service fee</p>
            <div className="rate-body">
              <p className="result-price">
                {!tier && <span className="price-lead">Starting at</span>}
                <span className="price-figure">{displayPrice}</span>
                <span className="price-unit">/month</span>
              </p>
              {tier && (
                <p className="result-meta">
                  Based on {count} employee{count === 1 ? '' : 's'}
                </p>
              )}
            </div>
          </div>

          <div className="payroll-band-cell payroll-includes-cell">
            <p className="payroll-cell-label">What’s included</p>
            <ul className="check-list">
              {payrollIncludes.map((item) => (
                <li key={item}>
                  <span className="check" aria-hidden="true">
                    ✓
                  </span>
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="payroll-footer" data-reveal>
          <a
            className="btn btn-primary"
            href={contact.schedulingHref}
            target="_blank"
            rel="noopener noreferrer"
          >
            Get Started
          </a>
        </div>
      </div>
    </section>
  );
}
